import { ErrorCallbackFunction, StringOrNothing, getObject, getText, putVoid } from '../ChoiceApi'
import { ICompanySetting } from '../Models/CompanySettingModel';
import { ProductType } from '../../Enums/ChoiceEnums';

export async function isProductActive(productType: ProductType, errorCallback?: ErrorCallbackFunction): Promise<boolean|undefined>
{
    const resp = await getText(`api/CompanySetting/Product/Active/${productType}`, errorCallback);
    if (undefined === resp)
        return;
    return "1" === resp || "true" === resp;
}

export async function getCompanySetting(settingType: CompanySettingType): Promise<ICompanySetting | undefined> {
    return await getObject<ICompanySetting>(`api/CompanySetting/Get/${settingType.parameterName}/${settingType.parameterOrder}`);
}

export async function getCompanySettingByParameterName(parameterName: string): Promise<Record<number, ICompanySetting> | undefined> {
    const resp = await getObject<ICompanySetting[]>(`api/CompanySetting/Get/${parameterName}`);
    let dictionary: Record<number, ICompanySetting> = {};
    resp?.forEach(
        companySetting => {
            dictionary[companySetting.parameterOrder] = companySetting;
        }
    )
    return dictionary;
}

export async function setCompanySettings(parameterName: string, companySettings: ICompanySetting[]): Promise<StringOrNothing> {
    return await putVoid(`api/CompanySetting/Put/${parameterName}`, companySettings);
}

export async function getIntVal(settingType: CompanySettingType): Promise<number | undefined> {
    const valResp = await getObject<ICompanySetting>(`api/CompanySetting/Get/${settingType.parameterName}/${settingType.parameterOrder}`);
    if (!valResp?.parameterValue)
        return;
    return +valResp.parameterValue;
}

export async function getBoolVal(settingType: CompanySettingType): Promise<boolean | undefined> {
    const valResp = await getObject<ICompanySetting>(`api/CompanySetting/Get/${settingType.parameterName}/${settingType.parameterOrder}`);
    if (undefined === valResp)
        return;
    switch(valResp.parameterValue)
    {
        case "1":
        case "Y":
        case "true":
        return true;

        case "0":
        case "N":
        case "false":
        return false;        
        
        default:
        alert(`Invalid boolean value: ${valResp.parameterValue} for ${settingType.parameterName}/${settingType.parameterOrder}`);
        return;
    }
}


// The company settings type information
export class CompanySettingType
{
    parameterName: string;
    parameterOrder: number;
    valueType: ParameterValueTypes;

    constructor(parameterName: string, parameterOrder: number, valueType: ParameterValueTypes)
    {
        this.parameterName = parameterName;
        this.parameterOrder = parameterOrder;
        this.valueType = valueType;
    }
}

export enum ParameterValueTypes
{
    Integer = 1,
    Number = 2,
    Text = 3,
    Date = 4,
    Time = 5,
    SocialSecurityNumber = 6,
    Boolean = 7,
    ein = 8,
    Currency = 9,
    Phone = 10,
    ZipCode = 11,
    String = 12,
    ComboBox = 13,
}

export const Setup = 
{
    MaximumNumberSignonAttempts: new CompanySettingType("Setup", 2, ParameterValueTypes.Integer),
    MaximumNumberDaysPasswordIsValid: new CompanySettingType("Setup", 3, ParameterValueTypes.Integer),
    DoNotAllowOldPasswordToBeReused: new CompanySettingType("Setup", 4, ParameterValueTypes.Boolean),
    MinimumPasswordLength: new CompanySettingType("Setup", 5, ParameterValueTypes.Integer),
    MostRecentlyUsedPasswordCount: new CompanySettingType("Setup", 9, ParameterValueTypes.Integer),
    AllowUsersToResetTheirPasswords: new CompanySettingType("Setup", 10, ParameterValueTypes.Boolean),
    AdditionalUserCount: new CompanySettingType("Setup", 11, ParameterValueTypes.Integer),
    IntakeAutoCreateTemporaryMMLAccount: new CompanySettingType("Setup", 13, ParameterValueTypes.Boolean),
    IntakeSendLinks: new CompanySettingType("Setup", 14, ParameterValueTypes.Boolean),
    IntakeCreateMMLAccount: new CompanySettingType("Setup", 15, ParameterValueTypes.Integer),
    Default2FASettingForUsers: new CompanySettingType("Setup", 16, ParameterValueTypes.Integer),
    PatientHeader_DisplayChartNumber: new CompanySettingType("Setup", 17, ParameterValueTypes.Boolean)
}
